import React, { Component } from 'react';
import { URLImgFront } from '../../../config/URLDB';

class Seccion03CooperaGanaMas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeButton: null,
            page: 0
        };
    }

    getActiveButton = (isActive) => {
        return {
            outline: 'none',
            display: 'block',
            margin: 'auto',
            transition: 'transform 0.15s ease',
            transform: isActive ? 'scale(0.96)' : 'scale(1)',
            backgroundColor: 'transparent',
            border: 0
        };
    }

    scrollToStar = () => {
        const target = document.getElementById("seccion01");
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    handleTogglePage = () => {
        this.setState(prevState => ({
            page: prevState.page === 0 ? 1 : 0
        }));
    };


    render() {
        const { activeButton } = this.state;

        const items = [
            { texto: "Consignar tu aporte mínimo mensual:", puntos: 100 },
            { texto: "Por cada $50.000 de incremento mensual sobre la cuota mínima de aportes sociales:", puntos: 50 },
            { texto: "Cumplir con el incremento del promedio mínimo mensual de ahorro a la vista ($100.000):", puntos: 50 },
            { texto: "Mantener al día tu ahorro programado:", puntos: 50 },
            { texto: "Tener tu CDAT activo:", puntos: 50 },
            { texto: "Tener tus obligaciones crediticias al día:", puntos: 50 },
            { texto: "Recibir tu salario en UTRAHUILCA:", puntos: 50 },
            { texto: "Tener tu tarjeta débito UTRAHUILCA activa y realizar retiros o pagos:", puntos: 50 },
            { texto: "Tener tu multiportal (App Móvil) activo y realizar retiros, pagos o transferencias:", puntos: 50 },
            { texto: "Por cada crédito que desembolses: ", puntos: 100 },
            { texto: "Por cada producto de ahorro programado que apertures o renueves:", puntos: 100 },
            { texto: "Por cada CDAT que constituyas o renueves:", puntos: 100 },
            { texto: "Por cada plan de previsión exequial que adquieras o renueves con UTRAHUILCA: ", puntos: 100 },
            { texto: "Por cada póliza de protección familiar que adquieras o renueves con UTRAHUILCA:", puntos: 100 },
        ];

        const { page } = this.state;

        const ITEMS_PER_PAGE = Math.ceil(items.length / 2);

        const visibleItems = items.slice(
            page * ITEMS_PER_PAGE,
            (page + 1) * ITEMS_PER_PAGE
        );

        return (
            <React.Fragment>
                <section className="planestimulos-contenedor" style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/FondoBlanco.jpg)`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
                    <div className="planestimulos-contenido">
                        <div className="planestimulos-seccion">
                            <div className="titleContainer">
                                <h2 className="planestimulos-titulo" data-aos="flip-up" data-aos-delay="300">Así podrás acumular</h2>
                                <p data-aos="flip-down" data-aos-delay="300" className="planestimulos-titulo-segundario biggerv2">puntos de</p>
                            </div>
                            <div className="planestimulos-sorteo-img">
                                <img src={`${URLImgFront}/assets/EstrategiasComerciales/FormaMensual.svg`} data-aos="zoom-out" data-aos-delay="300" alt="InfoPremiosCamp" width='490px' height='113px' />
                            </div>

                            <div className="planestimulos-sorteo-img">
                                <img src={`${URLImgFront}/assets/EstrategiasComerciales/CadaAccion.svg`} data-aos="zoom-out" data-aos-delay="300" alt="InfoPremiosCamp" width="636px" height="115px" />
                            </div>

                            <div className="planestimulos-sorteo-img centered">
                                <img src={`${URLImgFront}/assets/EstrategiasComerciales/PelotaAzul.svg`} data-aos="zoom-out" data-aos-delay="300" alt="InfoPremiosCamp" width="148px" height="148px" />
                            </div>
                        </div>

                        <div className="planestimulos-texto">
                            {visibleItems.map((item, i) => (
                                <div className="planestimulos-item" key={i}>
                                    <div className="planestimulos-item-left ">
                                        <img src={`${URLImgFront}/assets/EstrategiasComerciales/ItemGris.svg`} alt="icon" className="planestimulos-icon" />
                                        <p className="text itemsWrapper">{item.texto}</p>
                                    </div>
                                    <span className="text planestimulos-puntos">{item.puntos} puntos</span>
                                </div>
                            ))}

                            <div className='planestimulos-btn-container planestimulos-adaptable'>
                                <button id="btnToggle" className="button-img" onClick={this.handleTogglePage} style={this.getActiveButton(activeButton === 0)} >
                                    <img data-aos="zoom-in" data-duration="900" data-aos-delay="300" src={ page === 0 ? `${URLImgFront}/assets/EstrategiasComerciales/BotonAvanzarAzul.svg` : `${URLImgFront}/assets/EstrategiasComerciales/BotonAtrasAzul.svg` } alt="toggle" style={{ width: 'auto', height: '90px', touchAction: 'manipulation', maxWidth: '158px' }} />
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default Seccion03CooperaGanaMas;